import React, {Component} from "react";

const locale = (typeof (window.AppWizardLocale) !== 'undefined' ? window.AppWizardLocale : false);
if (!locale) {
    throw new Error('Error: Locale not loaded');
}

class EventsList extends Component {
    constructor(props) {
        super(props);
        this.createEntries = this.createEntries.bind(this);
    }

    createEntries(item, index) {
        return (
            <article className={`cocktail-event cocktail-event--${item.slug} col-12 col-md-6 col-lg-4`} onClick={() => this.props.onItemClick(item.id)}>
                <header className="cocktail-event__header text-center">
                    <img src={item.image_url} alt="" className="cocktail-event__image"/>
                    <div className="cocktail-event__header-inner d-flex flex-column justify-content-center align-items-center text-center">
                        <h3 className="cocktail-event__title" dangerouslySetInnerHTML={{__html: item.title}}/>
                        <a href="#" className="cocktail-event__link">Vezi rețete</a>
                    </div>
                </header>
                <div className="cocktail-event__description" dangerouslySetInnerHTML={{__html: item.description}}/>
            </article>
        );
    }

    render() {
        return (
            <div className="d-flex flex-column flex-md-row flex-wrap justify-content-center align-items-start">
                {this.props.items.map(this.createEntries)}
            </div>
        );
    }
}

export default EventsList;
